module.exports = __webpack_public_path__ + "static/media/path2.d49abcff.png";